import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { UserService } from '../user.service';

export const useGetUsers = (
	params: Users.UserParams,
	options?: Omit<
		UseQueryOptions<Users.GetUsersRespose, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: [
			'users',
			params.search,
			params.is_complete,
			params.is_member,
			params.banned,
			params.club_id,
			params.company_id,
			params.page,
			params.limit,
		],
		queryFn: () => UserService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetUser = (
	params: Users.GetDetail,
	options?: Omit<UseQueryOptions<Users.User, Error>, 'queryKey' | 'queryFn'>,
) => {
	return useQuery({
		queryKey: ['user', params.id, params.isMe],
		queryFn: () => UserService.getById(params),
		refetchOnWindowFocus: false,
		...options,
	});
};
